var THREE         = require("three");
var Handle3dView  = require("./../../../abstract/handle3dView.js");
var lib_core      = require("lib-core");

var GuiHandleView = function (model, editorView, handleId, config) {
    Handle3dView.call(this, model, editorView, handleId);

    var self = this;
    this.config = config;

    this.extraRadius = (this.config.extraRadius) ? this.config.extraRadius : 0;
    this.handleMesh = null;

    this.material = new THREE.MeshBasicMaterial( {
        color: this.config.color,
        side: THREE.DoubleSide,
        transparent: (this.config.opactiy == 1)?false: true,
        opacity: this.config.opacity
    } );

    //this.lastRadius = null;
    this.lastPosition = null;
    this.lastRotation = null;

    this.model.subjects.onBubble(this, function(){
        self.subjectsChanged(this);
    });

    this.editorView.cameraView.model.orthoZoom.onChange(this, function(val){
        self.setScale(val);
    });

}

lib_core.inherit(GuiHandleView, Handle3dView);

GuiHandleView.prototype.setScale = function(zoom){
    var scale = 1/zoom * 3;
    if(this.handleMesh){
        var position = (new THREE.Vector3()).setFromMatrixPosition(this.handleMesh.matrix)
        var rotation = (new THREE.Matrix4()).extractRotation(this.handleMesh.matrix);
        var quaternion = (new THREE.Quaternion()).setFromRotationMatrix(rotation);
        var scale = new THREE.Vector3(scale,scale,scale);
        this.handleMesh.matrix.compose(position, quaternion, scale);
    }
}

GuiHandleView.prototype.subjectsChanged = function(subjects){


   
    if(subjects.size() == 0){
        this.destroy();
        return;
    } 

    //var radius = this.model.getSubjectsRadius();
    var position = this.model.getSubjectsCenter();
    var rotation = this.model.getSubjectsRotation();


    // only rebuild if previously dead
     if(this.handleMesh == null){
         this.destroy();
         this.handleMesh = this.buildMesh(5);
         this.editorView.guiGroup.add(this.handleMesh);
         this.editorView.addMeshToSelectableList(this.handleMesh, this.model, true);
         this.repositionMesh(this.handleMesh, position, rotation);
         this.setScale(this.editorView.cameraView.model.orthoZoom());
     }

    // only move if position or rotation has changed
    if(!this.lastPosition || !position.eq(this.lastPosition) || !this.lastRotation || !rotation.eq(this.lastRotation)){
        this.repositionMesh(this.handleMesh, position, rotation);
        this.setScale(this.editorView.cameraView.model.orthoZoom());
    }

    //this.lastRadius = radius;
    this.lastPosition = position.copy();
    this.lastRotation = rotation.copy();

    this.editorView.render();
}

GuiHandleView.prototype.repositionMesh = function(mesh, position){
    console.error("not implimented");
}

GuiHandleView.prototype.hoverChanged = function(){
    console.error("not implimented");
} 


GuiHandleView.prototype.buildMesh = function(radius){
    console.error("not implimented");
}


GuiHandleView.prototype.destroy = function(){
    if(this.handleMesh != null){
        this.editorView.removeMeshFromSelectableList(this.handleMesh);
        this.editorView.guiGroup.remove(this.handleMesh);
        this.editorView.destroyObject(this.handleMesh);
        this.handleMesh = null;
    }
}


module.exports = GuiHandleView;

